import React from "react";
import PropTypes from "prop-types";

// @styles
import "./okNgoBoxFooter.scss";

const OkNgoBoxFooter = ({ onClickFunction, FormattedText }) => {
    const footerText = <FormattedText value="ngosSelector-showDetailsFooter" />;

    return (
        <span className="ok-ngo-footer" onClick={onClickFunction}>
            {footerText}
        </span>
    );
};

OkNgoBoxFooter.propTypes = {
    onClickFunction: PropTypes.func,
    FormattedText: PropTypes.func
};

OkNgoBoxFooter.defaultProps = {
    onClickFunction: () => null,
    FormattedText: () => {throw "FormattedText not defined"}
};

export default OkNgoBoxFooter;
